const variationSelectClass = 'js-variable-select';
const variationColorClass = 'js-variable-color';

const allColors = document.querySelectorAll('.' + variationColorClass);
allColors.forEach(select => {
    select.addEventListener('click', triggerChangeOnColor);
});

function triggerChangeOnColor(event) {
    const { currentTarget } = event;
    const term = event.target.dataset.term;
    const slug = event.target.dataset.slug;
    const name = event.target.dataset.name;
    const select = document.getElementById(term);
    const label = document.getElementById('js-label-' + term);
    if (select) {
        resetColorsEls(allColors);
        currentTarget.classList.add('active');

        select.value = slug;
        select.dispatchEvent(new Event('change', { bubbles: true }));
        label.textContent = name;
    }
}

$(document).on('show_variation', function (event, variation) {
    console.log(variation)
    let domContainer = document.getElementById('js-price-container');
    if (domContainer && variation.price_html) {
        domContainer.classList.add('is-loading');
        domContainer.innerHTML = variation.price_html;
        domContainer.classList.remove('is-loading');
    }
});

function resetColorsEls(colorsEls) {
    if (!colorsEls) return;
    colorsEls.forEach(item => item.classList.remove('active'));
}